import React from 'react';

export default function CompList() {
    return (
        <>
            <div className='scroll-box'>
                <div className='container-fluid g-0 mt-3'>
                    <div className='row d-flex justify-content-between align-items-center mb-2 g-0 py-2'>
                        <div className='col-4'>
                            <input type="text" className="form-control form-control-sm" placeholder="Search" />
                        </div>
                        <div className='col-2 d-flex justify-content-center align-items-center p-2 rounded-1' style={{ backgroundColor: "#000", fontWeight: 400, color: "#fff", cursor: "pointer" }}>+ Add</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-12">
                            <div className='card p-2 border-0'>
                                <table className="table table-striped table-bordered table-sm align-middle ">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Name</th>
                                            <th>Position</th>
                                            <th>Year</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Name</td>
                                            <td>Position</td>
                                            <td>2024</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
